import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Billing, userQueryKeys } from '#api';
import { billingDetailsQueryOptions } from '#api/billing.queries.ts';

export function useCancelPlanMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: Billing.cancelPlan,
    async onSuccess() {
      await queryClient.invalidateQueries(billingDetailsQueryOptions);
      await queryClient.invalidateQueries({ queryKey: userQueryKeys.all() });
    },
  });
}
